import { InProductTrialTypeEnum } from '@nirvana/shared/dtos/types/in-product-trials';
import { LicenseProductIdEnum } from '@nirvana/shared/license-helper';
import { BaseWebComponentTranslator } from '../../../framework/BaseWebComponentTranslator';

export function getTranslatedInProductTrialType(type: InProductTrialTypeEnum): string {
  const translator = BaseWebComponentTranslator.getInstance();

  const xdrCommonName = 'GravityZone XDR';

  const inProductTrialTypeTranslated: {
    [trialType in InProductTrialTypeEnum]: () => string;
  } = {
    [InProductTrialTypeEnum.OfficeSecurityPack]: () =>
      translator.translateProductId(LicenseProductIdEnum.ProductIdOfficeSecurityPack),
    [InProductTrialTypeEnum.NextGen]: () => translator.translateProductId(LicenseProductIdEnum.ProductIdNextGen),
    [InProductTrialTypeEnum.NextGenWithReconfigurePopup]: () =>
      translator.translateProductId(LicenseProductIdEnum.ProductIdNextGen),
    [InProductTrialTypeEnum.Atd]: () => translator.translateProductId(LicenseProductIdEnum.ProductIdAtd),
    [InProductTrialTypeEnum.XdrFull]: () => xdrCommonName,
    [InProductTrialTypeEnum.XdrSensors]: () => xdrCommonName,
    [InProductTrialTypeEnum.PatchManagement]: () =>
      translator.translateProductId(LicenseProductIdEnum.ProductIdPatchManagement),
    [InProductTrialTypeEnum.VolumeEncryption]: () =>
      translator.translateProductId(LicenseProductIdEnum.ProductIdVolumeEncryption),
    [InProductTrialTypeEnum.MobileSecurity]: () =>
      translator.translateProductId(LicenseProductIdEnum.ProductIdMobileSecurity),
    [InProductTrialTypeEnum.IntegrityMonitor]: () =>
      translator.translateProductId(LicenseProductIdEnum.ProductIdIntegrityMonitorAddon),
    [InProductTrialTypeEnum.ContainerProtection]: () =>
      translator.translateProductId(LicenseProductIdEnum.ProductIdContainerProtection),
    [InProductTrialTypeEnum.StorageProtection]: () =>
      translator.translateProductId(LicenseProductIdEnum.ProductIdStorageProtection),
    [InProductTrialTypeEnum.MdrEnterprise]: () =>
      translator.translateProductId(LicenseProductIdEnum.ProductIdMdrPlus),
    [InProductTrialTypeEnum.Cws]: () => translator.translateProductId(LicenseProductIdEnum.ProductIdCws),
    [InProductTrialTypeEnum.ThreatIntel]: () => 'IntelliZone Portal',
    [InProductTrialTypeEnum.NadAndEraAddon]: () => translator.translateProductId(LicenseProductIdEnum.ProductIdNadAndEraAddon),
    [InProductTrialTypeEnum.WebAccessAndDeviceControlAddon]: () => translator.translateProductId(LicenseProductIdEnum.ProductIdWebAccessAndDeviceControlAddon),
    [InProductTrialTypeEnum.ComplianceManager]: () => translator.translateProductId(LicenseProductIdEnum.ProductIdComplianceManager),
  };

  return inProductTrialTypeTranslated[type] !== null
    ? inProductTrialTypeTranslated[type]()
    : translator.translateFn('N/A');
}
